import { unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${unit('xl')};
  overflow: hidden auto;
`;
